import { APIService } from "@/services/APIService/APIService";
import { useService } from "@/services/ServiceContext";
import * as React from "react";
import { useLocation, matchPath } from "react-router-dom";
import useSwr from "swr/immutable";
export function usePages() {
	const api = useService(APIService.serviceKey);
	return useSwr("pages", () => {
		return api.pageContent.listPageContent();
	});
}

export function usePage() {
	const location = useLocation();
	const pages = usePages();

	return React.useMemo(() => {
		const pgs = pages.data ?? [];
		return {
			pageContent: pgs.find((i) => matchPath(i.path!, location.pathname)),
			loading: pages.isLoading,
		};
	}, [location, pages.data, pages.isLoading]);
}
